export const calculateGrade = (percentage: number) => {
    if (percentage > 30) return 4;
    if (percentage > 20) return 3;
    if (percentage > 10) return 2;
    return 1;
}